import React from 'react';

import RIQButton from '../../../components/RIQButton.jsx';

export default function ContactUsButton() {
    if (window.Intercom) {
        return (
            <RIQButton
                onClick={() => window.Intercom('show')}
                variant='primary'
                className='tlw-px-6 tlw-py-3 tlw-text-md tlw-font-normal'
            >
                Contact Us
            </RIQButton>
        );
    } else {
        return (
            <RIQButton
                variant='primary'
                className='tlw-px-6 tlw-py-3 tlw-text-md tlw-font-normal'
            >
                <a
                    href='mailto:support@rivaliq.com'
                    className='tlw-text-white hover_tlw-text-white hover_tlw-no-underline'>
                        Contact Us
                </a>
            </RIQButton>
        );
    }
}
